import { Fragment, useState } from 'react';

import { ExportCsvButton } from '../../components/ui';
import { downloadCsv } from '../../utils/csv.js';

// Built in the browser: the endpoint returns the whole (short) batch list, so
// there is nothing the export could reach that the table doesn't already hold.
const CSV_COLUMNS = [
  { key: 'id',                label: 'Batch ID' },
  { key: 'source',            label: 'Source' },
  { key: 'date_range_start',  label: 'From' },
  { key: 'date_range_end',    label: 'To' },
  { key: 'records_extracted', label: 'Records' },
  { key: 'status',            label: 'Status' },
  { key: 'started_at',        label: 'Started' },
  { key: 'completed_at',      label: 'Completed' },
  { key: 'error_message',     label: 'Error' },
];

export function BatchesTable({ batches }) {
  // Batch ids whose error detail row is expanded ("View error" toggles).
  const [openErrors, setOpenErrors] = useState(() => new Set());

  if (!batches?.extraction_batches?.length) return null;

  const toggleError = (id) => {
    setOpenErrors((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  return (
    <div className="section">
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 12, flexWrap: 'wrap',
      }}>
        <div className="section-title">Extraction Batches</div>
        <ExportCsvButton
          onExport={() => downloadCsv(
            'extraction-batches', batches.extraction_batches, CSV_COLUMNS,
          )}
          title="Download these extraction batches as CSV"
        />
      </div>
      <table>
        <thead>
          <tr>
            <th>Source</th><th>Date Range</th><th>Records</th>
            <th>Status</th><th>Started</th><th style={{ width: 120 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {batches.extraction_batches.map((b) => (
            <Fragment key={b.id}>
              <tr>
                <td>{b.source}</td>
                <td>
                  {b.date_range_start && b.date_range_end
                    ? `${b.date_range_start} to ${b.date_range_end}`
                    : b.started_at?.slice(0, 10)}
                </td>
                <td>{b.records_extracted != null ? b.records_extracted : '—'}</td>
                <td>
                  <span
                    className={`badge ${
                      b.status === 'completed' ? 'approved' :
                      b.status === 'failed' ? 'failed' : 'pending'
                    }`}
                  >
                    {b.status}
                  </span>
                </td>
                <td style={{ fontSize: 12 }}>{b.started_at}</td>
                <td>
                  {b.status === 'failed' && b.error_message ? (
                    <button
                      onClick={() => toggleError(b.id)}
                      title="Show the error message recorded for this batch"
                      style={{
                        background: 'none', border: 'none', padding: 0,
                        color: '#b00020', cursor: 'pointer', fontSize: 12,
                        textDecoration: 'underline',
                      }}
                    >
                      {openErrors.has(b.id) ? 'Hide error' : 'View error'}
                    </button>
                  ) : null}
                </td>
              </tr>
              {openErrors.has(b.id) && (
                <tr>
                  <td colSpan={6} style={{ background: '#fdf3f4', padding: '8px 12px' }}>
                    <pre
                      style={{
                        margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                        fontSize: 12, color: '#721c24', fontFamily: 'inherit',
                      }}
                    >
                      {b.error_message}
                    </pre>
                  </td>
                </tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
